import Controller from './close_when_clicked_outside_controller';

export default class extends Controller {
  toggle() {
    this._opened = !this._opened;
  }

  open() {
    this._opened = true;
  }

  close() {
    this._opened = false;
  }

  get _opened() {
    return this.element.classList.contains('flex-dropdown-menu--open');
  }

  set _opened(value) {
    this.element.classList.toggle('flex-dropdown-menu--open', value);
  }
}
